import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import * as z from 'zod'

export const searchSchema = z.object({
  returnUrl: z.string().optional()
})

export const ManageSARRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `$id/edit`,
    component: lazyRouteComponent(() => import('./ManageSARPageWrapper')),
    validateSearch: (search) => searchSchema.parse(search)
  })
